
















































import { Vue, Component } from 'vue-property-decorator';
import avatar from 'vue-avatar';
import PostEditor from './PostEditor.vue';
import VueToastr from '@deveodk/vue-toastr';
import { vxm } from '@/store.vuex';
import WlAvatar from '@/components/Commons/WlAvatar.vue';

@Component({
  components: {
    avatar,
    WlAvatar,
    PostEditor,
  },
})
export default class PostWriter extends Vue {
  $wlToastr: any;
  private showAvatar: boolean = true;
  private uploadProfileFileUrl: string = '';
  get FullName() {
    return (
      vxm.users.myUserProfile.firstName + ' ' + vxm.users.myUserProfile.lastName
    );
  }

  get currentUser() {
    return vxm.users.myUserProfile;
  }

  hideModal() {
    this.$bvModal.hide('modal-create-post');
  }

  get appTheme() {
    return vxm.utility.AppTheme;
  }
}
